import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('flex-center-content', {
  template: require('./template.html'),
  name: 'flex-center-content',
  computed: {
    ...mapGetters(['viewport', 'activeDroplet']),
  },
  props: ['option', 'active-state', 'dom-nodes'],
  data() {
    return {
      display: {},
      debTime: 250,
      innerDomNodes: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
    activeState() {
      this.setInitialValue();
    },
  },
  created() {
    // setup defaults from payload models
    _.forOwn(this.option.payload.models, (model) => {
      this.$set(this.display, model.name, model.default);
    });
    // then check for previous values
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      const option = this.option;
      this.display[option.payload.models.value.name] = this.getValFlex(option.payload);
    },
    getValFlex(params) {
      let shown = this.option.payload.models.value.default;
      const useRoot = this.option.$el === 'root';
      const $root = this.domNodes.$dropletRow;
      const $el = useRoot ? $root : $root.querySelectorAll(this.option.$el)[0];
      const first = params.updates[0];
      const selector = first.selector;
      const property = first.property;
      const rule = this._rule(
        this.activeDroplet,
        this.viewport,
        selector,
        property,
      );
      if ((rule.status === 'not-present' || rule.status === 'default') && $el) {
        const styles = window.getComputedStyle($el);
        shown = styles[property];
      }
      if (rule.status === 'inherit') {
        shown = rule.prop.desktop;
      }
      if (rule.status === 'custom') {
        shown = rule.prop[this.viewport];
      }
      return shown === 'center';
    },
    onChange(params) {
      const payload = {};
      payload.drp = this.activeDroplet;
      payload.val = this.buildVal(params);
      payload.viewport = this.viewport;
      _.forEach(params.updates, (item) => {
        const selector = item.selector.replace(/\$\{state\}/gi, this.activeState);
        payload.property = item.property;
        payload.selector = selector;
        this.$emit('check-legacy-styles', payload);
        this.$store.dispatch('changeDropletCss', payload);
      });
      this.checkLegacyProps();
      this.$emit('css-generator', false, this.option.plugin);
      this.$emit('update-changes', true);
    },
    checkLegacyProps() {
      if (this.activeDroplet.centerContainer) {
        this.$store.dispatch('setDropletVal', {
          drp: this.activeDroplet,
          key: 'centerContainer',
          val: false,
        });
      }
      const flexClass = _.findIndex(this.activeDroplet.sectionClassList, item => item === 'flex-center-all');
      if (flexClass >= 0) {
        this.$store.dispatch('spliceDropletVal', {
          array: this.activeDroplet.sectionClassList,
          index: flexClass,
        });
      }
    },
    buildVal(params) {
      const value = this.display[params.models.value.name];
      return value ? 'center' : 'initial';
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/section-options/flex-center-content/index.js